import { useEffect, useState } from "react"
import { EthereumWalletConnectors } from "@dynamic-labs/ethereum"
import { useReferrer } from ".."

const useWeb3Auth = () => {
	const [error, setError] = useState<string | undefined>(undefined)
	const [message, setMessage] = useState<string | undefined>(undefined)
	const [signedMessage, setSignedMessage] = useState<string | undefined>(undefined)

	const { referrerUrl } = useReferrer()

	const handleSignedMessage = (params: { messageToSign: string, signedMessage: string }) => {
		console.log("Signed message", params)
		setSignedMessage(params.signedMessage)
		setMessage(params.messageToSign)
		return true
	}

	const handleAuthInit = async (data: any) => {
		console.log("onAuthInit was called", data)
		return true
	}

	const handleConnectWallet = async (wallet: any) => {
		console.log("handleConnectWallet", wallet)
		return true
	}

	const handleAuthUser = async (user: any) => {
		console.log("Authenticated user", user)
	}

	const handleAuthSuccess = async (user: any) => {
		console.log("Authenticated user", user)
		// const authToken = getAuthToken()
		// console.log('Auth token', authToken)
	}

	const handleOnboarding = async (missingFields: unknown) => {
		console.log("User onboarded", missingFields)
	}

	const handleLogout = async () => {
		console.log("Logout")
	}

	const handleAuthFlowCancel = async () => {
		console.log("onAuthFlowCancel was called")
	}

	const handleAuthFailure = async (data: unknown, reason: unknown) => {
		console.log("onAuthFailure was called", data, reason)
		if (reason === "user-cancelled") {
			setError("error.generic")
		}
		// @ts-expect-error - dynamic does not export their event types
		if ("error" in reason) {
			// @ts-expect-error
			switch (reason?.error?.code as number) {
				case 4001:
					setError("error.user-rejected-request")
					break

				default:
					setError("Oops, something went wrong!")
			}
		}
	}

	const dynamicSettings = {
		environmentId: process.env.REACT_APP_DYNAMIC_ENVIRONMENT_ID || "The environment id for this build is missing",
		walletConnectors: [EthereumWalletConnectors],
		authMode: "connect-and-sign",
		debugError: true,
		// logLevel:"DEBUG",
		events: {
			onSignedMessage: handleSignedMessage,
			onAuthInit: handleAuthInit,
			onLogout: handleLogout,
			onAuthSuccess: handleAuthSuccess,
			onAuthFailure: handleAuthFailure,
			onAuthFlowCancel: handleAuthFlowCancel,
		},
		handlers: {
			handleUserOnboarding: handleOnboarding,
			handleConnectedWallet: handleConnectWallet,
			handleAuthenticatedUser: handleAuthUser,
		},
	}
	/** only sets error status code */
	const [statusCode, setStatusCode] = useState<number | undefined>(undefined)

	const authenticateWithEdge = async () => {
		try {
			const response = await fetch(process.env.REACT_APP_API_URL || "", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				credentials: 'include',
				body: JSON.stringify({
					message: message,
					signature: signedMessage,
				}),
			})

			if (response.ok) {
				if (response.status === 200) {
					window.location.href = referrerUrl || `https://rivalrymirror.com/l/token`
				}
			}
			// set the status code since it wont appear on the catch block
			setStatusCode(response.status)
		} catch (err: {
			error?: string
			message?: string
		} | unknown) {
			switch ((err as { error?: string }).error as string) {
				// 400
				case "invalid-signature":
					setError("error.invalid-signature")
					break
				case "cannot-create-session":
					setError("error.cannot-create-session")
					break
				default:
					// if error is already set, break out of the switch
					if (error) return
					// otherwise, set the error based on status code
					switch (statusCode) {
						case 429:
							setError("error.too-many-requests")
							break
						case 401:
							setError("error.unauthorized")
							break
						default:
							setError("error.generic")
							break
					}
			}
		}
	}

	useEffect(() => {
		if (message && signedMessage) {
			authenticateWithEdge()
		}
	}, [message, signedMessage])

	useEffect(() => {
		if (statusCode) {
			setStatusCode(statusCode)
		}
		if (error) {
			setError(error as string)
		}

		return () => {
			setTimeout(() => {
				setError(undefined)
				setStatusCode(undefined)
			}, 5000)
		}
	}, [error])

	return {
		dynamicSettings,
		error, setError,
		message,
		signedMessage,
		authenticateWithEdge,
	}
}

export default useWeb3Auth
